export default function() {
  return (
    <img src={require('../../assets/images/image-4.jpg')} className="ticket-form-thumbnail-img" />
  );
}